import { getSigners } from 'lib/api/business';
import { Signer } from 'lib/api/business/types';
import {
  translateCountry,
  translateMaritalStatus,
} from 'lib/consts/usersFields';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import Table, { Header } from 'lib/designSystem/Table';
import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import AssignSigner from './Components/AssignSigner';
import CreateSigner from './Components/CreateSigner';
import UpdateSigner from './Components/UpdateSigner';

const Signers = () => {
  const { id: businessIdentifier } = useParams();
  const dispatch = useDispatch();
  const [openCreateSigner, setOpenCreateSigner] = useState(false);
  const [openAssignSigner, setOpenAssignSigner] = useState(false);
  const [openUpdateSigner, setOpenUpdateSigner] = useState(false);
  const [selectedSigner, setSelectedSigner] = useState<Signer | null>(null);
  const { data, isPending } = getSigners(dispatch, businessIdentifier);
  const tableHeaders: Header[] = [
    { key: 'identifier', label: 'Rut' },
    { key: 'name', label: 'Nombre' },
    { key: 'email', label: 'Email', type: 'copyable' },
    { key: 'phone', label: 'Teléfono' },
    { key: 'translateCountry', label: 'Nacionalidad' },
    { key: 'profession', label: 'Profesión' },
    { key: 'translateMaritalStatus', label: 'Estado civil' },
  ];

  const signers =
    data?.map((signer) => ({
      ...signer,
      translateCountry: translateCountry(signer.country),
      translateMaritalStatus: translateMaritalStatus(signer.maritalStatus),
    })) ?? [];

  const handleClickRow = (row: number) => {
    setOpenUpdateSigner(true);
    const signer = signers.find((signer) => signer.id === row);
    setSelectedSigner(signer ?? null);
  };

  const buttons: CustomButtonProps[] = [
    {
      action: () => setOpenAssignSigner(true),
      name: 'Asignar firmante',
      color: 'secondary',
    },
    {
      action: () => setOpenCreateSigner(true),
      name: 'Agregar firmante',
      color: 'primary',
    },
  ];

  if (isPending) return <CenteredCircularProgress type="dialog" />;

  return (
    <>
      <HeaderWithActions
        title="Lista con los firmantes de la empresa."
        buttons={buttons}
        variant="body1"
      />
      <Table
        data={signers}
        dataHeaders={tableHeaders}
        handleClickRow={handleClickRow}
      />
      <CreateSigner
        open={openCreateSigner}
        setOpen={setOpenCreateSigner}
        businessIdentifier={businessIdentifier}
      />
      <AssignSigner
        open={openAssignSigner}
        setOpen={setOpenAssignSigner}
        businessIdentifier={businessIdentifier}
      />
      <UpdateSigner
        open={openUpdateSigner}
        setOpen={setOpenUpdateSigner}
        businessIdentifier={businessIdentifier}
        signer={selectedSigner}
      />
    </>
  );
};

export default Signers;
